"use client";

import { Mail, MapPin, Phone } from "lucide-react";
import type React from "react";
import type { FooterContactInfo } from "@/types";

export interface FooterContactProps {
  contactInfo: FooterContactInfo;
}

const FooterContact: React.FC<FooterContactProps> = ({ contactInfo }) => {
  const { address, contact, hours } = contactInfo;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
      {/* Address Column */}
      <div>
        <h4 className="text-xl font-semibold text-black mb-4">
          {address.title}
        </h4>
        <div className="flex items-start gap-3 mb-4">
          <MapPin className="w-5 h-5 text-black/60 mt-0.5" />
          <div>
            <p className="text-black/80 font-medium">{address.street}</p>
            <p className="text-black/60">{address.city}</p>
          </div>
        </div>
        <p className="mt-4">
          <a
            href={address.mapLink}
            target="_blank"
            rel="noopener noreferrer"
            className="text-black hover:text-black/70 transition-colors underline underline-offset-8 decoration-black/30"
          >
            View on Map
          </a>
        </p>
      </div>

      {/* Contact Details Column */}
      <div>
        <h4 className="text-xl font-semibold text-black mb-4">
          {contact.title}
        </h4>
        <div className="space-y-3 mb-4">
          <div className="flex items-center gap-3">
            <Phone className="w-5 h-5 text-black/60" />
            <span className="text-black/80">{contact.phone}</span>
          </div>
          <div className="flex items-center gap-3">
            <Mail className="w-5 h-5 text-black/60" />
            <span className="text-black/80">{contact.email}</span>
          </div>
        </div>
        <p className="mt-4">
          <a
            href={`mailto:${contact.email}?subject=${encodeURIComponent(contact.emailSubject)}`}
            className="text-black hover:text-black/70 transition-colors underline underline-offset-8 decoration-black/30"
          >
            Send Message
          </a>
        </p>
      </div>

      {/* Kitchen Hours Column */}
      <div>
        <h4 className="text-xl font-semibold text-black mb-4">{hours.title}</h4>
        <div className="space-y-2">
          {hours.schedule.map((item) => (
            <div
              key={item.days}
              className="flex justify-between border-b border-black/10 pb-2"
            >
              <span className="text-black/70">{item.days}</span>
              <span className="text-black/80 font-medium">{item.time}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FooterContact;
